<template>
    <v-sheet v-if="user?._id">
        <qrcode-vue :value="user?._id" :size="178" class="d-flex justify-center pa-7" />
        <v-divider />
        <v-card-text class="pa-4">
            <v-row class="ma-0">
                <v-col cols="auto" sm="3" class="font-weight-bold">이름</v-col>
                <v-col>{{ user.name }}</v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="auto" sm="3" class="font-weight-bold">회원번호</v-col>
                <v-col>{{ user._id }}</v-col>
            </v-row>
        </v-card-text>
    </v-sheet>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
    components: {
        QrcodeVue,
    },
    props: {
        user: { type: Object, default: () => ({}) },
    },
};
</script>

<style>
</style>